import { render, staticRenderFns } from "./send.vue?vue&type=template&id=7f7b9642&scoped=true"
import script from "./send.vue?vue&type=script&lang=js"
export * from "./send.vue?vue&type=script&lang=js"
import style0 from "./send.vue?vue&type=style&index=0&id=7f7b9642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7b9642",
  null
  
)

export default component.exports